import React, { forwardRef } from 'react';
import propTypes from 'prop-types';
import { getCompany } from 'helpers/getCompanyVariables';
import { Tooltip } from '@mui/material';
import Button from 'tailwind-components/Button';

const company = getCompany();

const isOneill = company === 'oneill';

// the ref lands on the wrapper span so the sidebar can watch whether the button is scrolled into view
const SendRequestButton = forwardRef(function SendRequestButton(
  { isDisabled, isSendingRequestAppointments, onSubmit },
  ref
) {
  return (
    <Tooltip
      title={
        isOneill && !isDisabled
          ? 'Carriers may terminate appointments after 12 months of no production. Request only what you plan to sell.'
          : ''
      }
      placement='top'
      arrow
    >
      <span ref={ref} className='inline-flex w-full'>
        <Button
          disabled={isDisabled}
          isLoading={isSendingRequestAppointments}
          size='medium'
          variant='primaryLight'
          text='Send Request'
          fill
          onClick={onSubmit}
        />
      </span>
    </Tooltip>
  );
});

SendRequestButton.propTypes = {
  isDisabled: propTypes.bool.isRequired,
  isSendingRequestAppointments: propTypes.bool.isRequired,
  onSubmit: propTypes.func.isRequired
};

export default SendRequestButton;
